import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"

import {FormattedMessage} from "@irati/utils/lang"
import {H2, H4} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import teamService from "@irati/identity/services/teams"
import id from "@irati/utils/id"
import {User, Team} from "@irati/types"
import Flex from "@irati/ui/src/Flex"

import {StyledDiv} from "./styled"
import {UserHeader} from "../../Users/User/index"
import AddUserToTeamUserRow from "../AddUserToTeamUserRow/AddUserToTeamUserRow"
import UserListData from "../../../components/UserList"

interface Props {
  currentTeam: Team,
  onSuccess: () => void,
  id?: string
}

interface State {
  selectedEmployees: [],
  submit: Promise<any> | null
}

class AddUsersToTeam extends Component<Props, State> {
  static defaultProps = {
    currentTeam: null,
    id: "add-users-to-team"
  }

  state: State = {
    selectedEmployees: [],
    submit: null
  }

  toggleSelectedUsers = (user: User) => {
    this.setState((state) => {
      let {selectedEmployees} = state
      if (selectedEmployees.find((test) => test.uuid === user.uuid)) {
        selectedEmployees = selectedEmployees.filter((test) => test.uuid !== user.uuid)
      } else {
        selectedEmployees = [...selectedEmployees, user]
      }

      return {
        selectedEmployees
      }
    })
  }

  handleUserSubmit = () => {
    const submit = Promise.all(
      this.state.selectedEmployees.map((user) => teamService.addUserToTeam(this.props.currentTeam.uuid, user.uuid))
    ).then(() => {
      this.props.onSuccess()
    })

    this.setState({submit})
    return submit
  }

  render() {
    const {selectedEmployees, submit} = this.state
    const {currentTeam} = this.props

    return (
      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={12}>
              <StyledDiv>
                <H2 marginBottom={4}>
                  <FormattedMessage
                    id="admin.components.addUserToTeam.headerTwo.addPeople"
                    values={{currentTeam: currentTeam.public_name}} />
                </H2>
              </StyledDiv>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Flex justifyContent="space-between" alignItems="center" marginBottom={2}>
                <H4>
                  <FormattedMessage
                    id="admin.components.addUserToTeam.headerFour.selectedEmployees"
                    values={{selectedEmployeesLength: selectedEmployees.length}} />
                </H4>
                <Button id={id("save-button", this.props)} primary className="pull-right" onClick={this.handleUserSubmit} load={submit}>
                  <FormattedMessage id="admin.components.addUserToTeam.button.text" />
                </Button>
              </Flex>

              <UserListData ref={this.userList} teamId={null}>
                {({users}) => (
                  <>
                    <UserHeader header="admin.components.addUserToTeam.userHeader.email" />
                    {users.results.map((user) => (
                      <AddUserToTeamUserRow
                        key={user.uuid}
                        user={user}
                        selectedEmployees={selectedEmployees}
                        currentTeam={currentTeam}
                        updateSelectedUser={this.toggleSelectedUsers} />
                    ))}
                  </>
                )}
              </UserListData>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default AddUsersToTeam
